(function () {
  const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  const numberFrom = value => {
    const match = String(value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  };
  const isPositiveNumber = value => Number.isFinite(value) && value > 0;
  const sameDimension = (left, right) => Number.isFinite(left) && Number.isFinite(right) && Math.abs(left - right) < 0.001;
  const createCartAddPayload = (variantId, quantity, sections, sectionsUrl) => ({
    items: [{ id: Number(variantId), quantity: Number(quantity) }],
    sections,
    sections_url: sectionsUrl
  });

  function createVariantMatrix(variants, widthPosition, lengthPosition) {
    const option = (variant, position) => variant.options[position] || '';
    const variantWidth = variant => numberFrom(option(variant, widthPosition));
    const variantLength = variant => numberFrom(option(variant, lengthPosition));
    const validVariants = variants.filter(variant => {
      const width = variantWidth(variant);
      const length = variantLength(variant);
      const variantPrice = Number(variant.price);
      return isPositiveNumber(width) && isPositiveNumber(length) && Number.isFinite(variantPrice) && variantPrice >= 0;
    });
    const widths = [...new Set(validVariants.map(variantWidth))].sort((a, b) => b - a);
    const variantsForWidth = width => validVariants.filter(variant => sameDimension(variantWidth(variant), width));
    const findVariant = (width, length) => validVariants.find(variant => sameDimension(variantWidth(variant), width) && sameDimension(variantLength(variant), length));
    return { validVariants, widths, variantsForWidth, findVariant, variantWidth, variantLength };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { numberFrom, isPositiveNumber, sameDimension, createVariantMatrix, createCartAddPayload };
  }
  if (typeof document === 'undefined') return;

  function replaceSectionHtml(id, html) {
    if (!html) return;
    const current = document.getElementById('shopify-section-' + id);
    if (!current) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.getElementById('shopify-section-' + id);
    if (next) current.innerHTML = next.innerHTML;
  }

  function shopifyRootPath() {
    const configured = window.Shopify?.routes?.root || '/';
    return configured.endsWith('/') ? configured : configured + '/';
  }

  function fireCartEvent(name, detail) {
    [document.documentElement, document, document.body].filter(Boolean).forEach(target => {
      try { target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail })); } catch (error) {}
    });
    try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch (error) {}
  }

  function updateVisibleCartValues(cart) {
    if (!cart) return;
    const count = Number(cart.item_count || 0);
    const total = Number(cart.total_price || 0);
    const countSelectors = [
      '[data-cart-count]', '[data-cart-item-count]', '.cart-count', '.cartCount',
      '.js-cart-count', '.site-header__cart-count', '.Header__CartCount',
      '.cart-link__bubble-num', '.hc-items-count', '#CartCount', '#cartCount'
    ];
    document.querySelectorAll(countSelectors.join(',')).forEach(element => {
      const target = element.matches('#CartCount, #cartCount') ? element.querySelector('span') || element : element;
      target.textContent = String(count);
      element.hidden = false;
      element.classList.remove('hidden', 'hidden-count', 'is-empty');
    });
    document.querySelectorAll('[data-cart-total], [data-cart-subtotal], #cart-price, .cart-total .money, .cart__subtotal .money, .mini-cart__total .money, .hc-buttons .amount').forEach(element => {
      element.textContent = money(total);
    });
  }

  function refreshHCSideCart(cart) {
    if (!cart) return false;
    const appendTargets = Array.from(document.querySelectorAll('.hc-append'));
    if (!appendTargets.length) return false;
    document.querySelectorAll('.hc-mini-table').forEach(table => table.remove());
    appendTargets.forEach(container => {
      container.replaceChildren();
      const table = document.createElement('table');
      table.className = 'hc-mini-table';
      (cart.items || []).forEach(item => {
        const row = document.createElement('tr');
        row.className = 'item-details';
        row.dataset.id = String(item.id);

        const imageCell = document.createElement('td');
        imageCell.className = 'td-image';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.product_title || item.title || '';
          imageCell.appendChild(image);
        }

        const detailsCell = document.createElement('td');
        const titlePrice = document.createElement('div');
        titlePrice.className = 'mini_cart_title_price';
        const title = document.createElement('div');
        title.textContent = item.product_title || item.title || '';
        titlePrice.appendChild(title);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          titlePrice.appendChild(document.createTextNode(' ' + item.variant_title + ' '));
        }
        const itemPrice = document.createElement('span');
        itemPrice.className = 'item-price';
        itemPrice.textContent = money(item.final_price ?? item.price ?? 0);
        titlePrice.appendChild(itemPrice);
        detailsCell.appendChild(titlePrice);

        const minus = document.createElement('a');
        minus.href = '';
        minus.className = 'minus-quantity';
        minus.textContent = '−';
        detailsCell.appendChild(minus);
        const quantityField = document.createElement('input');
        quantityField.type = 'text';
        quantityField.className = 'quantity-input';
        quantityField.value = String(item.quantity || 0);
        detailsCell.appendChild(quantityField);
        const plus = document.createElement('a');
        plus.href = '';
        plus.className = 'plus-quantity';
        plus.textContent = '+';
        detailsCell.appendChild(plus);
        const remove = document.createElement('a');
        remove.href = '';
        remove.className = 'hc-remove';
        remove.textContent = 'Remove';
        detailsCell.appendChild(remove);

        row.appendChild(imageCell);
        row.appendChild(detailsCell);
        table.appendChild(row);
      });
      container.appendChild(table);
    });
    updateVisibleCartValues(cart);
    return true;
  }

  function getThemeCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification') || null;
  }

  function getThemeCartSectionIds(cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
    try {
      return [...new Set((cartComponent.getSectionsToRender() || []).map(section => {
        if (typeof section === 'string') return section;
        return section?.section || section?.id || '';
      }).filter(Boolean))];
    } catch (error) {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
  }

  async function refreshCartDrawerMarkup(rootPath) {
    const response = await fetch(rootPath + 'cart', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    if (!response.ok) return false;
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const selectors = ['#sidebar-cart', '#CartDrawer', '#cartDrawer', '#cart-drawer', '#mini-cart', '[data-cart-drawer]', '.cart-drawer', '.mini-cart-popup'];
    let replaced = false;
    const handled = new Set();
    selectors.forEach(selector => {
      const current = document.querySelector(selector);
      const incoming = parsed.querySelector(selector);
      if (!current || !incoming || handled.has(current)) return;
      current.innerHTML = incoming.innerHTML;
      handled.add(current);
      replaced = true;
    });
    return replaced;
  }

  function openThemeCart(detail, cartComponent) {
    if (cartComponent && typeof cartComponent.open === 'function') {
      try { cartComponent.open(); return; } catch (error) {}
    }
    fireCartEvent('cart:open', detail);
    fireCartEvent('theme:cart:open', detail);
    fireCartEvent('drawer:open', { ...detail, drawer: 'cart' });
    const selectors = [
      '[data-action="toggle-mini-cart"]', '[data-action="open-cart"]', '[data-cart-toggle]',
      '.js-open-cart', '.slide_out_cart_trigger', '[aria-controls="sidebar-cart"]',
      '[aria-controls="CartDrawer"]', '[aria-controls="cart-drawer"]'
    ];
    const opener = selectors.map(selector => document.querySelector(selector)).find(element => {
      if (!element) return false;
      if (element.tagName === 'BUTTON') return true;
      const href = element.getAttribute('href') || '';
      return href === '' || href === '#' || href.startsWith('javascript:');
    });
    if (opener) {
      try { opener.click(); } catch (error) {}
    }
  }

  async function refreshThemeCart(rootPath, cart, addResult, cartComponent) {
    const addedItem = Array.isArray(addResult?.items) ? addResult.items[0] : addResult;
    const detail = { cart, item: addedItem, product: addedItem, openMiniCart: true, source: 'ausgrass-sports' };
    let nativeRendered = false;
    if (cartComponent && typeof cartComponent.renderContents === 'function' && addResult?.sections) {
      try {
        cartComponent.classList?.remove('is-empty');
        cartComponent.querySelector?.('.drawer__inner')?.classList.remove('is-empty');
        cartComponent.renderContents({ ...addResult, ...addedItem, sections: addResult.sections });
        nativeRendered = true;
      } catch (error) {
        console.warn('Ausgrass cart drawer native refresh failed.', error);
      }
    }

    const hcRendered = refreshHCSideCart(cart);
    updateVisibleCartValues(cart);
    ['cart:refresh', 'cart:updated', 'cart:update', 'cart:change', 'theme:cart:added', 'product:added'].forEach(name => fireCartEvent(name, detail));

    if (!nativeRendered) {
      if (window.jQuery) {
        try {
          window.jQuery(document).trigger('cart:refresh', [cart]);
          window.jQuery(document.body).trigger('added.ajaxProduct');
          window.jQuery(document.body).trigger('afterCartLoad.ajaxCart', [cart]);
        } catch (error) {}
      }
      if (!hcRendered) {
        try {
          if (window.ajaxCart && typeof window.ajaxCart.load === 'function') window.ajaxCart.load();
          else if (window.theme?.ajaxCart && typeof window.theme.ajaxCart.load === 'function') window.theme.ajaxCart.load();
          else await refreshCartDrawerMarkup(rootPath);
        } catch (error) {
          try { await refreshCartDrawerMarkup(rootPath); } catch (fallbackError) {}
        }
      }
    }
    openThemeCart(detail, nativeRendered ? cartComponent : null);
    updateVisibleCartValues(cart);
  }

  function initGallery(root) {
    const main = root.querySelector('[data-ag-main-image]');
    if (!main) return;
    root.querySelectorAll('[data-ag-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        main.src = button.dataset.src;
        main.alt = button.dataset.alt || '';
        root.querySelectorAll('[data-ag-thumb]').forEach(item => {
          const active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-ag-tab-group]').forEach(group => {
      const buttons = group.querySelectorAll('[data-ag-tab]');
      const panels = group.querySelectorAll('[data-ag-panel]');
      const activate = value => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.agTab === value)));
        panels.forEach(panel => { panel.hidden = panel.dataset.agPanel !== value; });
      };
      buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.agTab)));
      if (buttons[0]) activate(buttons[0].dataset.agTab);
    });
  }

  function initMode(root, buttonSelector, panelSelector, stageSelector) {
    const buttons = root.querySelectorAll(buttonSelector);
    const panels = root.querySelectorAll(panelSelector);
    const stages = root.querySelectorAll(stageSelector);
    const activate = value => {
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mode === value)));
      panels.forEach(panel => { panel.hidden = panel.dataset.modePanel !== value; });
      stages.forEach(stage => stage.classList.toggle(stage.dataset.activeClass || 'is-active', stage.dataset.modeStage === value));
    };
    buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.mode)));
    if (buttons[0]) activate(buttons[0].dataset.mode);
  }

  function initStimp(root) {
    const buttons = root.querySelectorAll('[data-ag-stimp]');
    if (!buttons.length) return;
    const activate = value => {
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.agStimp === value)));
      root.querySelectorAll('[data-ag-stimp-panel]').forEach(panel => { panel.hidden = panel.dataset.agStimpPanel !== value; });
      root.querySelectorAll('[data-ag-stimp-lane]').forEach(lane => lane.classList.toggle('is-active', lane.dataset.agStimpLane === value));
      root.querySelectorAll('[data-speed-row]').forEach(row => row.classList.toggle('selected-speed', row.dataset.speedRow === value));
    };
    buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.agStimp)));
    activate(buttons[0].dataset.agStimp);
  }

  function initProduct(root) {
    const form = root.querySelector('[data-ag-product-form]');
    const dataNode = root.querySelector('[data-ag-product-json]');
    if (!form || !dataNode) return;
    let variants = [];
    try { variants = JSON.parse(dataNode.textContent || '[]'); } catch (error) { variants = []; }
    const widthPosition = Number(form.dataset.widthOption || 1) - 1;
    const lengthPosition = Number(form.dataset.lengthOption || 2) - 1;
    const widthWrap = form.querySelector('[data-ag-widths]');
    const lengthSelect = form.querySelector('[data-ag-length]');
    const quantity = form.querySelector('[data-ag-quantity]');
    const quantityOutput = form.querySelector('[data-ag-quantity-output]');
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    const addButton = form.querySelector('[data-ag-add]');
    const status = form.querySelector('[data-ag-cart-status]');
    const price = root.querySelector('[data-ag-unit-price]');
    const buttonPrice = form.querySelector('[data-ag-button-price]');
    const area = form.querySelector('[data-ag-area]');
    const totalArea = form.querySelector('[data-ag-total-area]');
    const stock = root.querySelector('[data-ag-stock]');
    let selectedWidth;
    let selectedLength;
    let selectedQuantity = 1;

    const matrix = createVariantMatrix(variants, widthPosition, lengthPosition);
    const { widths, variantsForWidth, findVariant, variantLength } = matrix;
    const selectedVariant = () => findVariant(selectedWidth, selectedLength);

    function update() {
      const variant = selectedVariant();
      const squareMetres = selectedWidth * selectedLength;
      const variantPrice = Number(variant?.price);
      if (!variant || !isPositiveNumber(squareMetres) || !Number.isFinite(variantPrice) || variantPrice < 0) {
        addButton.disabled = true;
        return;
      }
      variantInput.value = variant.id;
      quantityInput.value = selectedQuantity;
      quantityOutput.textContent = selectedQuantity;
      const total = variantPrice * selectedQuantity;
      price.textContent = money(variantPrice / squareMetres);
      buttonPrice.textContent = money(total);
      area.textContent = selectedWidth + 'm × ' + selectedLength + 'm × ' + selectedQuantity + (selectedQuantity === 1 ? ' piece' : ' pieces');
      totalArea.textContent = (squareMetres * selectedQuantity) + 'm² total';
      addButton.disabled = !variant.available;
      stock.textContent = variant.available ? form.dataset.inStock : form.dataset.soldOut;
    }

    function chooseWidth(width) {
      selectedWidth = width;
      widthWrap.querySelectorAll('button').forEach(button => {
        const active = Number(button.dataset.width) === width;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const available = variantsForWidth(width).sort((a, b) => variantLength(a) - variantLength(b));
      lengthSelect.innerHTML = available.map(variant => {
        const length = variantLength(variant);
        return '<option value="' + length + '"' + (variant.available ? '' : ' disabled') + '>' + length + ' ' + (length === 1 ? 'metre' : 'metres') + (variant.available ? '' : ' — sold out') + '</option>';
      }).join('');
      const firstAvailable = available.find(variant => variant.available) || available[0];
      selectedLength = firstAvailable ? variantLength(firstAvailable) : NaN;
      lengthSelect.value = String(selectedLength);
      const label = form.querySelector('[data-ag-length-range]');
      if (label && available.length) label.textContent = variantLength(available[0]) + 'm–' + variantLength(available[available.length - 1]) + 'm';
      update();
    }

    if (!variants.length || !widths.length) {
      addButton.disabled = true;
      stock.textContent = form.dataset.noProduct;
      return;
    }

    widthWrap.innerHTML = widths.map((width, index) => '<button class="segment' + (index === 0 ? ' active' : '') + '" type="button" data-width="' + width + '" aria-pressed="' + (index === 0) + '"><span class="width-main">' + width + ' metres</span></button>').join('');
    widthWrap.querySelectorAll('button').forEach(button => button.addEventListener('click', () => chooseWidth(Number(button.dataset.width))));
    lengthSelect.addEventListener('change', () => { selectedLength = Number(lengthSelect.value); update(); });
    form.querySelector('[data-ag-quantity-plus]').addEventListener('click', () => { selectedQuantity = Math.min(999, selectedQuantity + 1); update(); });
    form.querySelector('[data-ag-quantity-minus]').addEventListener('click', () => { selectedQuantity = Math.max(1, selectedQuantity - 1); update(); });
    chooseWidth(widths[0]);

    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.getAttribute('aria-busy') === 'true') return;
      const variant = selectedVariant();
      const squareMetres = selectedWidth * selectedLength;
      if (!variant || !variant.available || addButton.disabled || !isPositiveNumber(squareMetres)) return;
      variantInput.value = String(variant.id);
      quantityInput.value = String(selectedQuantity);
      form.setAttribute('aria-busy', 'true');
      addButton.disabled = true;
      status.textContent = form.dataset.adding;
      try {
        const rootPath = shopifyRootPath();
        const cartComponent = getThemeCartComponent();
        const sectionIds = getThemeCartSectionIds(cartComponent);
        const payload = createCartAddPayload(variant.id, selectedQuantity, sectionIds, window.location.pathname);
        const response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || form.dataset.error);

        if (result.sections) Object.entries(result.sections).forEach(([id, html]) => replaceSectionHtml(id, html));
        let cart = null;
        try {
          const cartResponse = await fetch(rootPath + 'cart.js', {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            cache: 'no-store'
          });
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (cartError) {
          console.warn('Ausgrass item was added, but cart state refresh failed.', cartError);
        }
        status.textContent = form.dataset.added;
        try {
          await refreshThemeCart(rootPath, cart, result, cartComponent);
        } catch (cartRefreshError) {
          console.warn('Ausgrass item was added, but the side cart could not be opened.', cartRefreshError);
        }
      } catch (error) {
        status.textContent = error.message || form.dataset.error;
      } finally {
        form.removeAttribute('aria-busy');
        addButton.disabled = !selectedVariant()?.available;
      }
    }, true);
  }

  function init(root) {
    if (!root || root.dataset.agReady === 'true') return;
    root.dataset.agReady = 'true';
    initGallery(root);
    initTabs(root);
    initMode(root, '[data-wicket-mode]', '[data-wicket-panel]', '[data-wicket-stage]');
    initMode(root, '[data-impact-mode]', '[data-impact-panel]', '[data-impact-stage]');
    initStimp(root);
    initProduct(root);
    root.querySelectorAll('[data-ag-scroll]').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector('#' + link.dataset.agScroll);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));
  }

  function initAll() { document.querySelectorAll('.ag-sports-root').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.ag-sports-root')));
})();
